import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  internetBannerData: null,
  latestInternet: null,
  pageForLatestInternet: 1
};

// *************************** Fetch Internet Banner ****************************
const fetchInternetBannerStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchInternetBannerSuccess = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    internetBannerData: action.internetBannerData,
    loading: false
  };
};

const fetchInternetBannerFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Latest Internet *************************
const fetchLatestInternetStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchLatestInternetSuccess = (state = INITIAL_STATE, action) => {
  let latestInternet = [];
  if (state.latestInternet === null && action.latestInternet.pageNumber === 1) {
    latestInternet = action.latestInternet.latestInternet;
  } else if (action.latestInternet.pageNumber === 1) {
    latestInternet = [...state.latestInternet];
  } else {
    latestInternet = [
      ...state.latestInternet,
      ...action.latestInternet.latestInternet
    ];
  }

  return {
    ...state,
    latestInternet: latestInternet,
    pageForLatestInternet: state.pageForLatestInternet + 1,
    loading: false
  };
};

const fetchLatestInternetFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_INTERNET_BANNER_START]: fetchInternetBannerStart,
  [Types.FETCH_INTERNET_BANNER_FAILURE]: fetchInternetBannerFailure,
  [Types.FETCH_INTERNET_BANNER_SUCCESS]: fetchInternetBannerSuccess,

  [Types.FETCH_LATEST_INTERNET_START]: fetchLatestInternetStart,
  [Types.FETCH_LATEST_INTERNET_FAILURE]: fetchLatestInternetFailure,
  [Types.FETCH_LATEST_INTERNET_SUCCESS]: fetchLatestInternetSuccess
};

// Create and Export Reducer
export const internetReducer = createReducer(INITIAL_STATE, HANDLERS);
